<template lang="pug">
  .modal.active
    .modal-overlay(@click='closeModal')
    .modal-container
      .modal-header
        button.btn.btn-clear.float-right(@click='closeModal')
        .modal-title.h5 {{step[currentStep].title}}
      .modal-body
        .content
          div(v-if='currentStep === 0')
            blockquote.message.warning
              b We're in beta!
              |  Thanks for checking us out! This part of the site is currently under heavy development. Please follow us on Twitter <a href="https://twitter.com/nonprofiters">@Nonprofiters</a> or <a href="https://twitter.com/heyozramos">@HeyOzRamos</a> to keep tabs on this feature. Thanks!
            blockquote.message.info
              b Did you know?
              |  Portland, OR is home to over 200 active organizations that can help you get anything you might need to live a more meaningful life. Right now. For free.
            p This form will help connect you to the resources you need. The more questions you answer the more directly we can help. You may update your responses at any time.
            p At the end, you will be given a step-by-step checklist of things to do that will improve your quality of life immediately!

          div(v-if='currentStep === 1')
            intake-form

      .modal-footer
        button.btn.btn-link.float-left(
          @click='prevStep'
          v-if='currentStep > 0') Back
        button.btn.btn-primary(
          @click='nextStep'
          v-if='currentStep < step.length - 1') Next
        button.btn.btn-primary(
          @click='createChecklist'
          v-if='currentStep === step.length - 1') Save Form
</template>





<script>
  import {mapState} from 'vuex'
  import IntakeForm from '@/components/checklist/Intake'
  import lockr from 'lockr'
  import firebase from 'firebase'
  require('firebase/firestore')

  export default {
    name: 'modal-intake',

    components: {
      IntakeForm
    },

    computed: mapState([
      'user',
      'checklist',
      'intakeConfig',
      'intakeData'
    ]),

    data () {
      return {
        currentStep: 0,

        // Determines whether to go back to the main route or just close the modal
        isInitialIntake: true,

        step: [
          {title: 'Intake: Overview'},
          {title: 'Intake: Form'}
        ]
      }
    },

    mounted () {
      this.$store.commit('setIntakeConfig', this.intakeData)

      // Skips immediately to the form if the user has filled it out
      this.currentStep = +Object.values(this.intakeData).some(data => !!data)

      if (this.checklist && Object.keys(this.checklist).length) {
        this.isInitialIntake = false
      } else {
        this.isInitialIntake = true
      }
    },

    methods: {
      closeModal () {
        this.$store.commit('toggleIntakeModal')
        if (this.isInitialIntake) this.$router.push('/')
      },

      nextStep () {
        this.currentStep = Math.min(this.step.length - 1, this.currentStep + 1)
      },

      prevStep () {
        this.currentStep = Math.max(0, this.currentStep - 1)
      },

      // Saves the checklist in localstorage and additionally in firestore if logged in
      createChecklist () {
        let data = {
          intake: Object.assign({}, this.intakeConfig)
        }

        // Only save if the user is logged in
        if (this.user.uid) {
          const db = firebase.firestore()
          data.updatedOn = firebase.database.ServerValue.TIMESTAMP
          data.user = this.user.uid
          db.collection('checklist').doc(this.user.uid).set(data, {merge: true})
        }

        lockr.set('intakeData', this.intakeConfig)
        this.$store.commit('setChecklist', data)
        this.closeModal()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/Intake.vue